module.exports = __webpack_public_path__ + "images/feature/group-1-b786a36964ef73e8388b9c73737e3d90.jpg";